/**
 * Chat event bus — decouples chat streaming from plugins (voice TTS, etc.).
 *
 * Any SSE handler dispatches events here. Any component can subscribe
 * without the chat code knowing about it.
 *
 * Events:
 *   - 'tts_text'        detail: { text: string }  (text chunk for TTS)
 *   - 'tts_stream_end'  detail: {}                 (LLM stream finished)
 *   - 'user_message'    detail: {}                 (user sent a message — stop TTS)
 *   - 'stt_toggle'      detail: {}                 (toggle mic on/off)
 *   - 'stt_start'       detail: {}                 (mic started)
 *   - 'stt_transcript'  detail: { text, isFinal }  (transcript from STT)
 *   - 'stt_stop'        detail: {}                 (mic stopped)
 *
 * Text transforms:
 *   Tools can register transform functions that process text before display.
 *   SSE handlers call chatEvents.transformText(raw) to get clean display text.
 */
const chatEvents = new EventTarget();

// ── Text transform registry ──
// Tools register functions that strip/transform text before rendering
const _textTransforms = [];

chatEvents.registerTextTransform = (fn) => {
  _textTransforms.push(fn);
  // Return unregister function
  return () => {
    const idx = _textTransforms.indexOf(fn);
    if (idx >= 0) _textTransforms.splice(idx, 1);
  };
};

chatEvents.transformText = (text) => {
  let result = text;
  for (const fn of _textTransforms) {
    result = fn(result);
  }
  return result;
};

export default chatEvents;
